<template>
    <el-container id="deviceContainer" v-loading="!loadingDone" v-draggable>
      <div>
        <h1>Devices of {{regionClicked}} ({{locationClicked}})</h1>
        <el-col :span="20" :offset="2">
          <el-input id="search" placeholder="Search by name" prefix-icon="el-icon-search" v-model="search" clearable/>
        </el-col>
        <div class="noData" v-if="filteredList.length<1">
          <h1>Nothing was found</h1>
        </div>
      </div>

      <div >
        <!-- This p displays only if dataReady is set to true so when the ajax function completed -->
        <p v-cloak class="device" v-for="element in filteredList" :key="element.deviceId">
          <router-link :to="`/device/${element.deviceId}`"><img class="oven" src="../media/oven.png"/>
            <span class="deviceName" :change="colorRegion()">{{element.deviceId}}</span> <br/> ({{element.location}})</router-link>
        </p>
      </div>
    </el-container>
</template>

<script>
  import axios from 'axios';
  import ElRow from "element-ui/packages/row/src/row";
  import { Draggable } from 'draggable-vue-directive'

  export default {
    directives: {
      Draggable,
    },
    name: 'Oven',
    props:['regionClicked', 'locationClicked', 'regionsColors', 'loadingDone'],
    data () {
      return {
        allData: [],
        search: '',
      }
    },
    methods: {
      checkRegionColor (name) {
        let isInside = false;
        this.regionsColors.forEach(function (oven) {
          if(oven.deviceName === name)
            isInside = oven.status;
        })
        return isInside;
      },
      /* Set the device's background color according to its own status */
      colorRegion(){
        let app = this;
        // This timeout is here because otherwise the coloring happens before the actual draw so it doesn't color it
        setTimeout(function () {
          let devices = document.getElementsByClassName("deviceName");
          Array.from(devices).forEach(function (device){
            if(app.checkRegionColor(device.innerHTML) === "OK")
              device.parentElement.parentElement.style.backgroundColor = "#80b855";
            else if(app.checkRegionColor(device.innerHTML) === "WARNING")
              device.parentElement.parentElement.style.backgroundColor = "#eaca44";
            else if(app.checkRegionColor(device.innerHTML) === "CRITICAL")
              device.parentElement.parentElement.style.backgroundColor = "#ef4d4d";
          })
        }, 10)
      }
    },
    computed:{
      filteredList(){
        var app = this;
        return this.allData.filter(element => {
          if(app.locationClicked === "all-regions")
            return element.deviceId.toLowerCase().includes(this.search.toLowerCase())
          else {
            if (element.location === app.locationClicked)
              return element.deviceId.toLowerCase().includes(this.search.toLowerCase())
            else
              return "";
          }
        })
      }
    },
    created: function () {
      var app = this

      axios.get('https://iiot.dave.eu/api/devices')
        .then(function (response) {
          app.allData = response.data;
        }).catch(function (error){
          console.error("ERRORE: " + error.response.data.message);
      })
    },
  }
</script>

<style scoped>
  *{
    text-align: center;
  }
  .el-container{
    display: inherit!important;
  }

  .el-input{
    transition: .15s all ease-out;
  }
  .el-input:hover{
    transform: scale(1.1);
  }

  /* Tablets and smaller */
  @media only screen and (max-width: 768px) {
    #deviceContainer {
      max-height: 35% !important;

      min-width: 85%;
      max-width: 100%;

      overflow: auto;
      border: 1px solid #ccc;
      padding-bottom: 2%;
      background-color: rgba(252, 252, 252, 0.66);
    }
  }

  .device {
    display: flex;
    padding-bottom: 1em;
    justify-content: center; /* align horizontal */
    align-items: center; /* align vertical */
  }

  /* This is the device shown */
  p {
    max-width: 10%;
    max-height: 10%;
    display: inline-table !important;
    cursor: pointer;
    border-radius: 10px;
    margin: 2%;
    padding: 1%;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
    transition: .15s all ease-out;
  }

  /* On hover the <p> becomes bigger */
  p:hover {
    transform: scale(1.1);

  }

  h1 {
    margin: 10px;
  }

  .oven {
    width: 5vw;
    min-width: 50px;
  }

  #deviceContainer {
    max-width: 20%;
    max-height: 50%;
    overflow: auto;
    border: 1px solid #ccc;
    border-radius: 10px 0 0 10px;
    padding-bottom: 2%;
    background-color: rgb(252, 252, 252);
    cursor: move;
  }

  /* Center the 'No device found' vertically */
  .noData {
    padding: 100px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Devices.vue